export const DEVICES_TECHNICAL_NAMES = {
    Bulb: "bulbv1",
    Thermostat: "thermostatv1",
    Camera: "camv1",
    Sfir: "sfir"
}